"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ErvNestedTiles = _interopRequireDefault(require("./ErvNestedTiles.scss"));

var _RemoteControlService = require("../../../KESI2/Services/RemoteControlService");

var _KESI2BasicComponent = _interopRequireDefault(require("../../../KESI2/KESI2BasicComponent"));

var _KesiConstants = require("../../../KESI2/KesiConstants");

var _KESI2Helper = _interopRequireWildcard(require("../../../KESI2/KESI2Helper"));

var _config = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/config.js"));

var _cssConstants = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/cssConstants.js"));

var _LogService = _interopRequireDefault(require("../../../KESI2/Services/LogService"));

var _NavigationManagerCordova = _interopRequireDefault(require("../../NavigationManagerCordova"));

var _ArrayHelper = require("../../../helpers/ArrayHelper");

var _ScreenHelper = _interopRequireDefault(require("../../../helpers/ScreenHelper"));

var _StringHelper = _interopRequireDefault(require("../../../helpers/StringHelper"));

var _TimeoutHelper = require("../../../helpers/TimeoutHelper");

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

var _NonFlippingTiles = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/NonFlippingTiles.js"));

var _DrupalNestedTileSizes = require("./DrupalNestedTileSizes");

var _Fade = _interopRequireDefault(require("@material-ui/core/Fade"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var NEEDED_WIDTH_XLARGE_SCREEN = 5 * _DrupalNestedTileSizes.TILE_SIZES.LARGE + 10 * _DrupalNestedTileSizes.MARGIN_BETWEEN_TILES;
var NEEDED_WIDTH_LARGE_SCREEN = 4 * _DrupalNestedTileSizes.TILE_SIZES.LARGE + 8 * _DrupalNestedTileSizes.MARGIN_BETWEEN_TILES;
var NEEDED_WIDTH_MEDIUM_SCREEN = 3 * _DrupalNestedTileSizes.TILE_SIZES.LARGE + 6 * _DrupalNestedTileSizes.MARGIN_BETWEEN_TILES;
var NEEDED_WIDTH_SMALL_SCREEN = 2 * _DrupalNestedTileSizes.TILE_SIZES.LARGE + 4 * _DrupalNestedTileSizes.MARGIN_BETWEEN_TILES;
var NEEDED_WIDTH_RESET_SCREEN = _DrupalNestedTileSizes.TILE_SIZES.LARGE + 2 * _DrupalNestedTileSizes.MARGIN_BETWEEN_TILES;

var DrupalNestedNonFlippingTiles = /*#__PURE__*/function (_Kesi2BasicComponent) {
  (0, _inherits2["default"])(DrupalNestedNonFlippingTiles, _Kesi2BasicComponent);

  var _super = _createSuper(DrupalNestedNonFlippingTiles);

  function DrupalNestedNonFlippingTiles(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, DrupalNestedNonFlippingTiles);
    _this = _super.call(this, props, context, props.currentId);
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "onWindowSizeChanged", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.setState({
                zoomValue: _this.calculateZoomValue()
              });

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "goUp", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var nextCompletePath;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (_this.state.navigationAllowed) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return", _promise["default"].reject(new Error('navigation not allowed')));

            case 2:
              nextCompletePath = (0, _ArrayHelper.getArrayWithoutLastElement)(_this.props.contentPathArray);

              if (!(nextCompletePath.length > 0)) {
                _context2.next = 7;
                break;
              }

              _context2.next = 6;
              return (0, _TimeoutHelper.timeout)();

            case 6:
              return _context2.abrupt("return", _NavigationManagerCordova["default"].goTo("".concat(_config["default"].baseRoute, "/").concat(nextCompletePath.join(_KesiConstants.KESI_PATH_DELIMITER))));

            case 7:
              return _context2.abrupt("return", _promise["default"].reject(new Error('Cannot go up')));

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "setCurrentRegionCache", function (currentRegion) {
      if (currentRegion) {
        console.log('setCurrentRegionCache', currentRegion);

        _this.setState({
          currentRegionCache: currentRegion
        });
      }
    });
    _this.outerPageId = _StringHelper["default"].createShortId();
    _this.state = _objectSpread({
      contentPathArray: null,
      idOfClickedContent: null,
      // the id of the content that will have a back side
      lastPath: [],
      flipped: false,
      animated: true,
      initialized: false,
      navigationAllowed: true,
      zoomValue: -1,
      showGoUpButtonOnBack: false,
      scrollTop: 0,
      closingTransitionForTile: null,
      // only when closing to root
      showBackground: false,
      showBackgroundTiles: false,
      hideTileForIdInBackground: null,
      // for fade transition remember some key values of previous state
      previousFlipped: false,
      previousIdOfClickedContent: null,
      fadeOutKey: 'fade1',
      // they swap on change
      fadeInKey: 'fade2',
      regionCode: null,
      currentRegionCache: null
    }, _this.state);
    _this.fadedElements = {};
    setTimeout(function () {
      // noinspection JSIgnoredPromiseFromCall  -->  don't wait for this promise to complete
      _this.initForEntityWithPath(props.contentPathArray, false);

      _this.setState({
        initialized: true
      });
    });
    return _this;
  }

  (0, _createClass2["default"])(DrupalNestedNonFlippingTiles, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _ScreenHelper["default"].instance().addOnWindowSizeChangedListener(this.onWindowSizeChanged);

                if (!_DeviceInfoHelper["default"].isBrowser()) {
                  window.screen.orientation.addEventListener('change', this.onWindowSizeChanged);
                }

                this.props.setShowFavButton(true);
                _context3.next = 5;
                return (0, _TimeoutHelper.timeout)();

              case 5:
                this.setState({
                  // eslint-disable-line react/no-did-mount-set-state  -->  because the warning is wrong
                  zoomValue: this.calculateZoomValue()
                });
                _context3.next = 8;
                return (0, _TimeoutHelper.timeout)(1000);

              case 8:
                this.setState({
                  lastPath: this.state.contentPathArray
                });

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(prevProps, prevState, snapshot) {
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                (0, _get2["default"])((0, _getPrototypeOf2["default"])(DrupalNestedNonFlippingTiles.prototype), "componentDidUpdate", this).call(this, prevProps, prevState, snapshot); // compare by stringify is okay because the paths only contain strings

                if ((0, _ArrayHelper.shallowEqual)(prevProps.contentPathArray, this.props.contentPathArray)) {
                  _context4.next = 4;
                  break;
                }

                _context4.next = 4;
                return this.initForEntityWithPath(this.props.contentPathArray);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function componentDidUpdate(_x, _x2, _x3) {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
    /*
    async componentWillReceiveProps (nextProps) {
      // compare by stringify is okay because the paths only contain strings
      if (!shallowEqual(this.props.contentPathArray, nextProps.contentPathArray)) {
        await this.initForEntityWithPath(nextProps.contentPathArray)
      }
    }
    */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(DrupalNestedNonFlippingTiles.prototype), "componentWillUnmount", this).call(this);

      _ScreenHelper["default"].instance().removeOnWindowSizeChangedListener(this.onWindowSizeChanged);

      if (!_DeviceInfoHelper["default"].isBrowser()) {
        window.screen.orientation.removeEventListener('change', this.onWindowSizeChanged);
      }
    }
  }, {
    key: "getScrollElementId",

    /** @namespace window.device */
    value: function getScrollElementId(forBackground) {
      return "scroll-frame-".concat(forBackground ? 'background' : 'not-background', "-").concat((0, _ArrayHelper.getLastElement)(this.state.contentPathArray));
    }
  }, {
    key: "getStyle",
    value: function getStyle() {
      var style = {
        backgroundTiles: {
          opacity: 1
        },
        backgroundTilesHidden: {
          opacity: 0
        },
        tileFrameRoot: {
          transform: 'translate3d(0, 0, 0)',
          transformOrigin: 'center',
          transition: 'transform 500ms',
          height: 'auto',
          backgroundColor: _cssConstants["default"].colors.backgroundColor ? _cssConstants["default"].colors.backgroundColor : 'white'
        },
        tileFrame: {
          transform: _config["default"].scaleOverlayTiles > 1 ? "translate3d(0, 0, 0) scale(".concat(_config["default"].scaleOverlayTiles, ")") : "translate3d(0, 0, 0)",
          transformOrigin: 'center',
          transition: 'transform 500ms, background-color 200ms',
          //        overflow: 'auto',
          overflow: 'hidden',
          // WebkitOverflowScrolling: 'touch',
          //height: target.showBottomBar ? `calc(100vh - ${targetCSS.navBarHeight}px - ${targetCSS.bottomBarHeight}px)` : `calc(100vh - ${targetCSS.navBarHeight}px)`,
          width: '100%',
          position: 'fixed',
          backgroundColor: _cssConstants["default"].colors.backgroundColor ? _cssConstants["default"].colors.backgroundColor : 'white'
        },
        tileFrameHidden: {
          opacity: 0,
          backgroundColor: 'transparent'
        }
      };
      style.tileFrameRootFlipped = (0, _assign["default"])({}, style.tileFrame);
      style.tileFrameRootFlipped.overflow = 'hidden';

      if (this.state.zoomValue < 0) {
        // hide everything until a appropriate zoom value is found
        style.tileFrame.opacity = 0;
        style.tileFrameRoot.opacity = 0;
        style.backgroundTiles.opacity = 0;
      }

      return style;
    }
  }, {
    key: "initForEntityWithPath",
    value: function () {
      var _initForEntityWithPath = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(nextPathArray) {
        var initLastPath,
            nextId,
            path,
            _args5 = arguments;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                initLastPath = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : true;

                if (this.state.navigationAllowed) {
                  _context5.next = 5;
                  break;
                }

                _context5.next = 4;
                return (0, _TimeoutHelper.timeout)(200);

              case 4:
                return _context5.abrupt("return", this.initForEntityWithPath(nextPathArray));

              case 5:
                nextId = (0, _ArrayHelper.getLastElement)(nextPathArray);
                path = _NavigationManagerCordova["default"].getCurrentPath();
                (0, _LogService["default"])(nextId, path);

                if ((0, _KESI2Helper.isRemoteControllingEnabled)()) {
                  (0, _RemoteControlService.pushNavigateMessage)(nextId, path);
                }

                this.setState({
                  lastPath: initLastPath ? this.props.contentPathArray || nextPathArray : null,
                  contentPathArray: nextPathArray,
                  previousFlipped: this.state.flipped,
                  previousIdOfClickedContent: this.state.idOfClickedContent,
                  fadeInKey: this.state.fadeOutKey,
                  fadeOutKey: this.state.fadeInKey
                });
                return _context5.abrupt("return", _promise["default"].resolve());

              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function initForEntityWithPath(_x4) {
        return _initForEntityWithPath.apply(this, arguments);
      }

      return initForEntityWithPath;
    }()
  }, {
    key: "calculateZoomValue",
    value: function calculateZoomValue() {
      var zoom = -1; // eslint-disable-line no-magic-numbers

      var outerPage = document.getElementById(this.outerPageId);

      if (outerPage) {
        var availWidth =
        /* target.showBottomBar ? outerPage.offsetWidth - 64 : */
        outerPage.offsetWidth;
        var divisor;

        if (availWidth >= NEEDED_WIDTH_XLARGE_SCREEN) {
          divisor = NEEDED_WIDTH_XLARGE_SCREEN;
        } else if (availWidth >= NEEDED_WIDTH_LARGE_SCREEN) {
          divisor = NEEDED_WIDTH_LARGE_SCREEN;
        } else if (availWidth >= NEEDED_WIDTH_MEDIUM_SCREEN * 0.8) {
          divisor = NEEDED_WIDTH_MEDIUM_SCREEN;
        } // else if (availWidth >= NEEDED_WIDTH_SMALL_SCREEN * 0.65) {
        else {
            divisor = NEEDED_WIDTH_SMALL_SCREEN;
          } // else {
        //   divisor = NEEDED_WIDTH_RESET_SCREEN
        // }


        zoom = availWidth / divisor;
      }

      return zoom;
    }
    /**
     * First time timeout: 600ms, always after: 0ms
     * @param elementId
     */

  }, {
    key: "getFadeTimeout",
    value: function getFadeTimeout(elementId) {
      var _this2 = this;

      if (this.fadedElements[elementId] === 2) {
        return 0;
      }

      if (!this.fadedElements[elementId]) {
        this.fadedElements[elementId] = 1;
        setTimeout(function () {
          _this2.fadedElements[elementId] = 2;
        }, 600);
      }

      return 600;
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.state.initialized) {
        return null; // return (
        //   <div>
        //     Lade.....
        //   </div>
        // )
      }

      var style = this.getStyle();

      var isRoot = (0, _ArrayHelper.getLastElement)(this.state.contentPathArray) === _KESI2Helper["default"].getSpocTree().id;

      var previousIsRoot = (0, _ArrayHelper.getLastElement)(this.state.lastPath) === _KESI2Helper["default"].getSpocTree().id;

      if (_config["default"].usesCourses) {
        isRoot = (0, _ArrayHelper.getLastElement)(this.state.contentPathArray) === _KESI2Helper["default"].getCourseTree().id;
        previousIsRoot = (0, _ArrayHelper.getLastElement)(this.state.lastPath) === _KESI2Helper["default"].getCourseTree().id;
      }

      var foregroundScrollId = this.getScrollElementId(false);
      var foregroundScrollStyle;
      var classNames = "scrollFrame";

      if (isRoot && !this.state.flipped) {
        foregroundScrollStyle = style.tileFrameRoot;
      } else if (!isRoot && this.state.flipped) {
        foregroundScrollStyle = style.tileFrameRootFlipped;
      } else {
        foregroundScrollStyle = style.tileFrame;

        if (_config["default"].openTilesInFullScreen) {
          classNames = "".concat(classNames, " ").concat(_ErvNestedTiles["default"].fullScreenTile);
        } else {
          if (_config["default"].showBottomBar) {
            classNames = "".concat(classNames, " ").concat(_ErvNestedTiles["default"].withBottomBar);
          } else {
            classNames = "".concat(classNames, " ").concat(_ErvNestedTiles["default"].withoutBottomBar);
          }
        }
      }

      var fadeOut = null; // performance
      // const fadeOut = !this.state.lastPath
      //   ? null
      //   : (
      //     <div className='scrollFrame' style={foregroundScrollStyle}>
      //       <Fade key={this.state.fadeOutKey} >
      //         <div className={s.tileContainer}>
      //           <ErvTiles
      //             contentPathArray={this.state.lastPath}
      //             renderChildrenForId={this.state.previousIdOfClickedContent}
      //             zoomValue={this.state.zoomValue}
      //             goUpFunc={() => {}}
      //             showGoUpButton={!target.showBackInNavBarInsteadOfCloseButtonForNuggets && this.state.navigationAllowed && this.state.contentPathArray.length >= 2}
      //             showGoUpButtonOnBack={!target.showBackInNavBarInsteadOfCloseButtonForNuggets && this.state.showGoUpButtonOnBack}
      //             navigationAllowed={this.state.navigationAllowed}
      //             isRoot={previousIsRoot}
      //             renderFront={target.scaleOverlayTiles >= 1 || !previousIsRoot || !this.state.previousFlipped}
      //             // scrollFrameId={foregroundScrollId}
      //             // showOnlyTileWithId={target.scaleOverlayTiles >= 1 ? null : this.state.closingTransitionForTile}
      //             // hideTileForId={target.scaleOverlayTiles >= 1 ? null : this.state.closingTransitionForTile}
      //             rootScrollTop={this.state.scrollTop}
      //             showBackground={target.scaleOverlayTiles >= 1 || this.state.showBackground}
      //             setBackButtonFunc={this.props.setBackButtonFunc}
      //             // setTitle={this.props.setTitle}
      //             fadeOut={true}
      //             setCurrentRegionCache={this.setCurrentRegionCache}
      //             currentRegionCache={this.state.currentRegionCache}
      //           />
      //         </div>
      //       </Fade>
      //     </div>
      //   )

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _ErvNestedTiles["default"].tileFrame,
        id: this.outerPageId
      }, fadeOut, /*#__PURE__*/_react["default"].createElement("div", {
        id: foregroundScrollId,
        className: classNames,
        style: foregroundScrollStyle
      }, /*#__PURE__*/_react["default"].createElement(_Fade["default"], {
        "in": true,
        key: this.state.fadeInKey,
        timeout: this.getFadeTimeout((0, _ArrayHelper.getLastElement)(this.state.contentPathArray))
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _ErvNestedTiles["default"].tileContainer
      }, /*#__PURE__*/_react["default"].createElement(_NonFlippingTiles["default"], {
        key: (0, _ArrayHelper.getLastElement)(this.state.contentPathArray),
        contentPathArray: this.state.contentPathArray,
        renderChildrenForId: this.state.idOfClickedContent,
        zoomValue: this.state.zoomValue,
        goUpFunc: this.goUp,
        showGoUpButton: !_config["default"].showBackInNavBarInsteadOfCloseButtonForNuggets && this.state.navigationAllowed && this.state.contentPathArray.length >= 2,
        showGoUpButtonOnBack: !_config["default"].showBackInNavBarInsteadOfCloseButtonForNuggets && this.state.showGoUpButtonOnBack,
        navigationAllowed: this.state.navigationAllowed,
        isRoot: isRoot,
        renderFront: _config["default"].scaleOverlayTiles >= 1 || !isRoot || !this.state.flipped,
        scrollFrameId: foregroundScrollId,
        showOnlyTileWithId: _config["default"].scaleOverlayTiles >= 1 ? null : this.state.closingTransitionForTile,
        hideTileForId: _config["default"].scaleOverlayTiles >= 1 ? null : this.state.closingTransitionForTile,
        rootScrollTop: this.state.scrollTop,
        showBackground: _config["default"].scaleOverlayTiles >= 1 || this.state.showBackground,
        setBackButtonFunc: this.props.setBackButtonFunc,
        setTitle: this.props.setTitle,
        showSettingsDialog: this.props.showSettingsDialog,
        setCurrentRegionCache: this.setCurrentRegionCache,
        currentRegionCache: this.state.currentRegionCache,
        setCount: this.props.setCount,
        setScrollBarHidden: this.props.setScrollBarHidden,
        setShowFavButton: this.props.setShowFavButton,
        isFirstLayer: this.props.isFirstLayer,
        outerCloseTile: this.props.outerCloseTile,
        outerDomId: this.props.outerDomId,
        closeTile: this.props.closeTile,
        domId: this.props.domId
      })))));
    }
  }]);
  return DrupalNestedNonFlippingTiles;
}(_KESI2BasicComponent["default"]);

DrupalNestedNonFlippingTiles.propTypes = {
  setTitle: _propTypes["default"].func,
  setCount: _propTypes["default"].func,
  setScrollBarHidden: _propTypes["default"].func.isRequired,
  setBackButtonFunc: _propTypes["default"].func.isRequired,
  contentPathArray: _propTypes["default"].array.isRequired,
  setShowFavButton: _propTypes["default"].func.isRequired,
  showSettingsDialog: _propTypes["default"].func,
  isFirstLayer: _propTypes["default"].bool,
  outerCloseTile: _propTypes["default"].func,
  outerDomId: _propTypes["default"].string
};
DrupalNestedNonFlippingTiles.defaultProps = {
  setTitle: function setTitle() {}
};
var _default = DrupalNestedNonFlippingTiles;
exports["default"] = _default;